import { Tag } from "antd";
import React, { FC } from "react";
import { EnumItemType } from "../../../types/appTypes";
import hexToRGB from "../../../utilities/colorUtil";

export interface TagFilterProps {
  tag: EnumItemType | null;
  disabled?: boolean;
  onClick?: () => void;
  active?: boolean;
  notActive?: boolean;
}

const TagFilter: FC<TagFilterProps> = ({ tag, disabled, active, notActive, onClick }) => {
  let styles: React.CSSProperties = {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 0,
    paddingBottom: 0,
    marginRight: 0,
    borderRadius: 16,
    fontWeight: 500,
    fontSize: 10,
    lineHeight: "16px",
  };

  if (disabled) {
    styles.color = "#95A5AE";
    styles.backgroundColor = "#EFF3F5";
    styles.textDecoration = "line-through"
  } else {
    styles.color = tag?.color ? tag?.color : "#fff";
    styles.backgroundColor = hexToRGB(tag?.color || "", 0.2);
  }

  return (
    <Tag
      onClick={!disabled && onClick ? onClick : undefined}
      style={styles}
      color={undefined}
      className={`tax-legal-filter-tag ${disabled ? "disabled" : ""} ${active ? "active" : ""} ${notActive ? "not-active" : ""} ${onClick ? "has-onClick" : ""}`}
    >
      {tag?.title}
    </Tag>
  );
};

export default TagFilter;
